import {BaseModel} from "../base/base.model";
export class ClientProcessorsModel extends BaseModel{
    id: number;
    client_id: number;
    processor: string;
    second_processor: string;
    former_processor: string;
    number_of_terminals: number;
    online: number;
    merchant_id_1: string;
    merchant_id_2: string;
    merchant_id_3: string;
    merchant_id_4: string;
    merchant_id_5: string;
    username: string;
    password: string;
    first_data: string;
}


// WEBPACK FOOTER //
// ./src/app/models/client-processors/client-processors.model.ts